export default function checkEnv() {
	const location = window?.location?.hostname?.split(".")[0];

	if (location === "localhost") {
		return "dev";
	}

	if (location !== "s3t-auth") {
		return "staging";
	} else {
		return "production";
	}
}
